import React, { useEffect, useRef, useState } from 'react';
import "../styles/About.css";
import bakımImage from '../assets/bakim3.png';
import { useTranslation } from 'react-i18next';

function About() {
  const aboutRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

useEffect(() => {
  const currentRef = aboutRef.current;

  const observer = new IntersectionObserver(
    ([entry]) => setIsVisible(entry.isIntersecting),
    { threshold: 0.3 }
  );

  if (currentRef) observer.observe(currentRef);

  return () => {
    if (currentRef) observer.unobserve(currentRef);
  };
}, []);

  return (
    <div className="about">
      <img src={bakımImage} alt="bakım görseli" className="aboutBackground" />
      <div className="aboutTop"></div>
      <div className={`aboutBottom ${isVisible ? 'visible' : ''}`} ref={aboutRef}>
        <h1>{t('about.whoAreWe')}</h1>
        <p>{t('about.p1')}</p>
        <p>{t('about.p2')}</p>
        <p>{t('about.p3')}</p>
        <h1>{t('about.vision')}</h1>
        <p>{t('about.visionText')}</p>
        <h1>{t('about.mission')}</h1>
        <p>{t('about.missionText')}</p>
      </div>
    </div>
  );
}

export default About;